module.exports = {
          srcSet: __webpack_public_path__ + "0eb176d0994fe66144d6795481a2fa8e-130.png"+" 130w",
          images:[ {path: __webpack_public_path__ + "0eb176d0994fe66144d6795481a2fa8e-130.png",width: 130,height: 46}],
          src: __webpack_public_path__ + "0eb176d0994fe66144d6795481a2fa8e-130.png",
          toString:function(){return __webpack_public_path__ + "0eb176d0994fe66144d6795481a2fa8e-130.png"},
          
          width: 130,
          height: 46
        }